// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3GYHN","footer":"ModalUpdate_footer__1hwBZ"};